import React from 'react';
import './Footer.css';

const Footer = () => {
	return (
		<div className="footer-container">
			<ul className="footer-items">
				<li className="footer-links">We're Hiring!</li>
				<li className="footer-links">Blog</li>
				<li className="footer-links">Sign Me Up!</li>
			</ul>
		</div>
	);
};

export default Footer;
